<div class="labeled-field-container">
  <label *ngIf="controlValue.value">{{placeholder}}</label>
  <input type="text" class="labeled-field border-radius-sm medium-text grey-accessible bg-grey-medium-light " autocomplete="off" autocorrect="off" autocapitalize="off" aria-label="{{ 'LABELED_FIELD.SEARCH_BY_TOPIC' | translate }}" [ngClass]="{'active': controlValue?.value}" [placeholder]="placeholder" [formControl]="controlValue">
</div>
